import { Card, CardBody, Col } from "reactstrap";
import { Badges, Image } from "../../../AbstractElements";
import { ImageBadgesTitle } from "../../../Constants/Constants";
import { ImageBadgesData, ImageBadgesSubTitle } from "../../../Data/UiKits/Tag&Pills";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { dynamicImage } from "../../../Utils";

const ImageBadges = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ImageBadgesTitle} span={ImageBadgesSubTitle} />
        <CardBody>
          <div className="badge-spacing image-badges">
            {ImageBadgesData.map((item, index) => (
              <Badges pill color="" className={`"common-align txt-${item.color === "light" ? "dark" : item.color} badge-l-${item.color} border border-${item.color}`} key={index}>
                <Image className="rounded-circle me-1" src={dynamicImage(`dashboard/${item.image}`)} alt="user" />
                {item.color}
              </Badges>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImageBadges;
